<template>
    <b-container
        fluid
        class="watermark-container"
    >
        <loading-animation
            class="loading"
            v-show="loading"
        ></loading-animation>

        <b-row v-show="!loading">
            <b-col
                sm="12"
                md="6"
            >
                <h4>{{ $t("Scegli lo stile") }}</h4>
                <b-row>
                    <b-col sm="6">
                        <b-form-radio
                            size="lg"
                            name="watermarkType"
                            value="TEXT"
                            v-model="watermark.tipo"
                            @change="onTypeChange"
                        >
                            {{ $t("Testo") }}
                        </b-form-radio>
                    </b-col>
                    <b-col sm="6">
                        <b-form-radio
                            size="lg"
                            name="watermarkType"
                            value="IMAGE"
                            v-model="watermark.tipo"
                            @change="onTypeChange"
                        >
                            {{ $t("Immagine") }}
                        </b-form-radio>
                    </b-col>
                </b-row>

                <b-row
                    class="mt-3"
                    v-show="watermark.tipo === 'TEXT'"
                >
                    <b-col sm="12">
                        <b-row>
                            <b-col>
                                <b-form-group :label="$t('Testo')">
                                    <b-form-input
                                        v-model="watermark.testo"
                                        @change="getSampleImagesUrl"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group :label="$t('Font')">
                                    <b-form-select
                                        v-model="watermark.fontTesto"
                                        @change="getSampleImagesUrl"
                                    >
                                        <b-select-option value="Arial">Arial</b-select-option>
                                        <b-select-option value="Georgia">Georgia</b-select-option>
                                        <b-select-option value="Verdana">Verdana</b-select-option>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group :label="$t('Colore')">
                                    <b-form-radio
                                        size="lg"
                                        name="watermarkTextColor"
                                        value="#000000"
                                        v-model="watermark.coloreTesto"
                                        @change="onColorTextChange"
                                    >
                                        {{ $t("Nero") }}
                                    </b-form-radio>

                                    <b-form-radio
                                        size="lg"
                                        name="watermarkTextColor"
                                        value="#ffffff"
                                        v-model="watermark.coloreTesto"
                                        @change="onColorTextChange"
                                    >
                                        {{ $t("Bianco") }}
                                    </b-form-radio>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row
                    class="mt-3"
                    v-show="watermark.tipo === 'IMAGE'"
                >
                    <b-col sm="12">
                        <b-row>
                            <b-col sm="9">
                                <b-form-group :label="$t('Immagine')">
                                    <b-form-file
                                        :placeholder="$t('Seleziona un file')"
                                        :browse-text="$t('Sfoglia')"
                                        accept="image/jpeg, image/png"
                                        @change="saveWatermarkImage($event)"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col sm="3">
                                <div class="image-preview-container">
                                    <b-spinner
                                        type="grow"
                                        v-show="loadingWatermarkImage"
                                    ></b-spinner>
                                    <canvas
                                        class="w-100 h-100"
                                        v-show="!loadingWatermarkImage"
                                        ref="watermarkImageCanvas"
                                    />
                                </div>
                            </b-col>
                        </b-row>
                        <b-row class="mt-3">
                            <b-col>
                                <b-form-group :label="$t('Posizione')">
                                    <b-form-select
                                        v-model="watermark.posizioneImmagine"
                                        @change="getSampleImagesUrl"
                                    >
                                        <b-select-option value="top-left">{{ $t("In alto a sinistra") }}
                                        </b-select-option>
                                        <b-select-option value="top-center">{{ $t("In alto al centro") }}
                                        </b-select-option>
                                        <b-select-option value="top-rigth">{{ $t("In alto a destra") }}
                                        </b-select-option>
                                        <b-select-option value="middle-left">{{ $t("A centro sinistra") }}
                                        </b-select-option>
                                        <b-select-option value="middle-center">{{ $t("Al centro") }}
                                        </b-select-option>
                                        <b-select-option value="middle-rigth">{{ $t("A centro destra") }}
                                        </b-select-option>
                                        <b-select-option value="bottom-left">
                                            {{ $t("In basso a sinistra") }}
                                        </b-select-option>
                                        <b-select-option value="bottom-center">
                                            {{ $t("In basso al centro") }}
                                        </b-select-option>
                                        <b-select-option value="bottom-rigth">
                                            {{ $t("In basso a destra") }}
                                        </b-select-option>
                                    </b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="mt-3">
                            <b-col sm="12">
                                <b-form-group :label="$t('Dimensione')">
                                    <b-form-input
                                        type="range"
                                        min="0.01"
                                        max="1"
                                        step="0.01"
                                        v-model="watermark.dimensioneImmagine"
                                        @change="getSampleImagesUrl"
                                    />
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col sm="12">
                        <b-form-group :label="$t('Opacità')">
                            <b-form-input
                                type="range"
                                min="0.01"
                                max="1"
                                step="0.01"
                                v-model="watermark.opacita"
                                @change="getSampleImagesUrl"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col sm="12">
                        <b-form-checkbox
                            size="lg"
                            name="watermarkMediaclip"
                            value="true"
                            v-model="watermark.mediaclip"
                            @change="onMediaclipChange"
                        >
                            {{ $t("Usa watermark anche nei progetti") }}
                        </b-form-checkbox>
                    </b-col>
                </b-row>
            </b-col>
            <b-col
                sm="12"
                md="6"
            >
                <h4>{{ $t("Anteprima") }}</h4>
                <b-row>
                    <b-col sm="6">
                        <img
                            class="mw-100"
                            :src="sampleImagePortraitUrl"
                        >
                    </b-col>
                    <b-col sm="6">
                        <img
                            class="mw-100"
                            :src="sampleImageLandscapeUrl"
                        >
                    </b-col>
                    <b-col></b-col>
                </b-row>
            </b-col>
        </b-row>

    </b-container>
</template>

<script>
import LoadingAnimation from "../../components/LoadingAnimation";

export default {
    name: "BackendWatermarkEditor",

    props: {
        idWatermark: { type: String, required: false, default: "" },
        idEvent: { type: String, required: false, default: "" }
    },

    components: {
        LoadingAnimation
    },

    data() {
        return {
            loading: false,
            saving: false,
            loadingWatermarkImage: false,
            watermark: {},
            sampleImagePortraitUrl: "",
            sampleImageLandscapeUrl: ""
        };
    },

    mounted() {
        this.loading = true;
        this.loadWatermark();
    },

    methods: {
        loadWatermark() {
            this.$api.backendGetWatermark(this.idWatermark).then((response) => {
                console.debug("BACKEND_GET_WATERMARK", response);
                this.watermark = response.watermark;
                this.getSampleImagesUrl();
                this.drawWatermarkImage();
                this.loading = false;
            });
        },

        onMediaclipChange(mediaclip) {
            this.watermark.mediaclip = mediaclip;
        },

        onTypeChange(tipo) {
            this.watermark.tipo = tipo;
            this.getSampleImagesUrl();
        },

        getSampleImagesUrl() {
            var watermark = {
                idWatermark: this.watermark.idWatermark,
                tipo: this.watermark.tipo,
                testo: this.watermark.testo,
                fontTesto: this.watermark.fontTesto,
                coloreTesto: this.watermark.coloreTesto,
                opacita: this.watermark.opacita,
                dimensioneImmagine: this.watermark.dimensioneImmagine,
                posizioneImmagine: this.watermark.posizioneImmagine
            };
            this.sampleImagePortraitUrl =
                this.$imagesService.getImageWithWatermarkUrl(
                    process.env.VUE_APP_WATERMARKS_SAMPLE_IMAGE_V,
                    watermark
                );
            this.sampleImageLandscapeUrl =
                this.$imagesService.getImageWithWatermarkUrl(
                    process.env.VUE_APP_WATERMARKS_SAMPLE_IMAGE_H,
                    watermark
                );
        },

        onColorTextChange(color) {
            this.watermark.coloreTesto = color;
            this.getSampleImagesUrl();
        },

        drawWatermarkImage() {
            if (this.watermark.immagine.length > 0) {
                var canvasElement = this.$refs.watermarkImageCanvas;
                var image = new Image();
                image.onload = function () {
                    var canvasW = canvasElement.width;
                    var canvasH = canvasElement.height;
                    canvasElement.width = canvasW;
                    canvasElement.height = canvasH;

                    var ctx = canvasElement.getContext("2d");
                    ctx.clearRect(0, 0, canvasW, canvasH);
                    /*
                     * EarlTP - 17-07-2018: fix scarsa qualita dei canvas, specialmente se piccoli (vedi collage con tante foto)
                     * vedi: https://www.html5rocks.com/en/tutorials/canvas/hidpi/
                     */
                    var devicePixelRatio = window.devicePixelRatio || 1;
                    var backingStoreRatio =
                        ctx.webkitBackingStorePixelRatio ||
                        ctx.mozBackingStorePixelRatio ||
                        ctx.msBackingStorePixelRatio ||
                        ctx.oBackingStorePixelRatio ||
                        ctx.backingStorePixelRatio ||
                        1;
                    var ratio = devicePixelRatio / backingStoreRatio;

                    //-- Upscale del canvas se i 2 ration non sono uguali
                    if (devicePixelRatio !== backingStoreRatio) {
                        var oldWidth = canvasElement.width;
                        var oldHeight = canvasElement.height;

                        canvasElement.width = oldWidth * ratio;
                        canvasElement.height = oldHeight * ratio;

                        canvasElement.style.width = oldWidth + "px";
                        canvasElement.style.height = oldHeight + "px";

                        // now scale the context to counter
                        // the fact that we've manually scaled
                        // our canvas element
                        ctx.scale(ratio, ratio);
                    }

                    var dx = 0,
                        dy = 0,
                        dw = canvasElement.width,
                        dh = canvasElement.height;
                    if (image.width > image.height) {
                        dh =
                            (canvasElement.height * image.height) / image.width;
                        dy = parseInt((canvasElement.height - dh) / 2);
                    } else {
                        dw = (canvasElement.width * image.width) / image.height;
                        dx = parseInt((canvasElement.width - dw) / 2);
                    }

                    ctx.drawImage(image, dx, dy, dw, dh);
                    ctx.setTransform(1, 0, 0, 1, 0, 0);
                };
                image.src = "data:image/png;base64," + this.watermark.immagine;
            }
        },

        saveWatermarkImage($event) {
            const file = $event.target.files[0];

            const reader = new FileReader();
            let _this = this;
            reader.onload = function (e) {
                var watermarkImage = e.target.result;
                if (watermarkImage) {
                    _this.loadingWatermarkImage = true;
                    _this.$api
                        .backendSaveWatermarkImage(
                            _this.idWatermark,
                            watermarkImage
                        )
                        .then((response) => {
                            _this.watermark.immagine = response.immagine;
                            _this.drawWatermarkImage();
                            _this.loadingWatermarkImage = false;
                            _this.sampleImagePortraitUrl = "";
                            _this.sampleImageLandscapeUrl = "";
                            _this.$nextTick(() => {
                                _this.getSampleImagesUrl();
                            });
                        });
                }
            };
            reader.readAsDataURL(file);
        },

        saveWatermark() {
            return new Promise((resolve, reject) => {
                this.saving = true;
                this.$api
                    .backendSaveWatermark(this.watermark)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    })
                    .finally(() => {
                        this.saving = false;
                    });
            });
        }
    }
};
</script>

<style scoped>
/*
.loading {
    position: relative;
    top: 50%;
    left: calc(50% - 41px);
}
*/
</style>
